import { render, staticRenderFns } from "./Ident.vue?vue&type=template&id=77ce8f20&scoped=true"
import script from "./Ident.vue?vue&type=script&lang=js"
export * from "./Ident.vue?vue&type=script&lang=js"
import style0 from "./Ident.vue?vue&type=style&index=0&id=77ce8f20&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ce8f20",
  null
  
)

export default component.exports